import React, { Component } from 'react';
import * as PropTypes from 'prop-types';
import { LinkStyles } from "./styles/LwolfLink.css";
import { Link } from 'react-router-dom';

class LwolfLink extends Component {

  constructor(props) {
    super(props);

    this.state = {
      hovered: false
    }
  }

  toggleHover = () => {
    this.setState({ hovered: !this.state.hovered });
  };


  render() {
    let hovered = this.state.hovered;
    let styles = {};
    if (this.props.additionalStyles) {
      Object.assign(styles, LinkStyles({ hovered }), this.props.additionalStyles);
    }
    else styles = LinkStyles({ hovered });
    let classNames = "";
    if (this.props.classNames != null && this.props.classNames.size) {
      this.props.classNames.forEach((className) => {
        classNames += className + " ";
      });
    }

    return (
      <div >
        <Link to={this.props.to}
          style={styles}
          className={classNames}
          onMouseEnter={() => {this.toggleHover()}}
          onMouseLeave={() => this.toggleHover()}>{this.props.text}
          </Link>
      </div>
    );
  }
}

LwolfLink.propTypes = {
  to: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  additionalStyles: PropTypes.object,
  classNames: PropTypes.array
};

export default LwolfLink;
